import React, { FC, useState } from 'react';
import map from 'lodash/map';
import { SettingsSelect, ChangeShippingWrapper } from './styled';
import Row from '../UI/Row';
import Button from '../UI/Button';
import CloseImage from '../UI/CloseImage';
import Text from '../UI/Text';
import { Mobile } from '../MediaQuery';
import { useAppContext } from '../../store/appContext';
import { useUrlBuilder } from '../../hooks/useUrlBuilder';

const ChangeShipping: FC<{ changeShippingVisibility: () => void }> = ({ changeShippingVisibility }) => {
  const { countryId, countries, countryCode } = useAppContext();
  const [selected, setSelected] = useState(countries.find(country => country.id === countryId));
  const [showWarning, setShowWarning] = useState(false);
  const { withCDN } = useUrlBuilder();

  const handleChange = e => {
    const newSelected = countries.find(country => country.id === e.target.value);
    const newShowWarning = newSelected.id !== countryId;
    setSelected(newSelected);
    setShowWarning(newShowWarning);
  };

  const saveShippingCountry = () => {
    const currUrl = window.location.pathname + window.location.search;
    const find = `^/${countryCode.toLowerCase()}`;
    const re = new RegExp(find);
    window.location.href = currUrl.replace(re, `/${selected.isoCode.toLowerCase()}`);
  };

  return (
    <ChangeShippingWrapper>
      <Mobile>
        <Row justifyContent="flex-end" margin="20px 30px">
          <CloseImage
            data-cy="close-change-shipping-country"
            onClick={changeShippingVisibility}
            src={withCDN('mkt/icon/x_black.png')}
          />
        </Row>
        <Row justifyContent="center" margin="0 0 10px">
          <Text fontFamily="Avenir Black" fontSize="12px">
            CHANGE SHIPPING COUNTRY
          </Text>
        </Row>
      </Mobile>
      <Row justifyContent="flex-start" margin="10px 15px 0px">
        <span>I'm shipping to: </span>
      </Row>
      <Row justifyContent="center" margin="5px 15px">
        <SettingsSelect data-cy="select-change-shipping-country" onChange={handleChange}>
          {map(countries, country => (
            /* eslint-disable-next-line eqeqeq */
            <option key={country.id} selected={country.id == countryId} value={country.id}>
              {country.country}
            </option>
          ))}
        </SettingsSelect>
      </Row>

      <Row data-cy="currency-text-change-shipping-country" justifyContent="flex-start" margin="5px 15px">
        <Text fontSize="13px">Your order will be billed in {selected.billingCurrency}</Text>
      </Row>

      <Row data-cy="warning-text-change-shipping-country" justifyContent="flex-start" margin="0px 15px 5px">
        {showWarning && (
          <Text color="red" fontSize="12px">
            Please note: the items in your shopping bag may be lost if you choose to proceed.
          </Text>
        )}
      </Row>

      <Row justifyContent="center">
        <Button
          backgroundColor="#000000"
          border="none"
          borderRadius="0px"
          color="#FFFFFF"
          data-cy="confirm-change-shipping-country"
          fontSize="13px"
          height="40px"
          margin="0 15px 10px"
          marginButton="0"
          onClick={saveShippingCountry}
          type="submit"
        >
          CONFIRM
        </Button>
      </Row>
    </ChangeShippingWrapper>
  );
};

export default ChangeShipping;
